/* ==========================================================================
   NUA DREAMS — producto.js
   La ficha de producto: la cantidad, la variante elegida, las fotos, la barra
   de compra del móvil y añadir a la cesta.

   Todo lo que hay aquí es una mejora encima de una ficha que ya funciona
   sola. Sin JavaScript, la ficha enseña un <select> con las variantes, un
   campo de cantidad y un botón que envía el formulario a /cart; las fotos se
   deslizan con el dedo igual (es scroll nativo) y la entrega dice «Llega en
   3-5 días laborables». Se puede comprar igual, sólo que con una recarga de
   página por medio.

   Lo que añade este archivo:
     · los botones + y − del contador
     · el precio, el stock, la referencia y la foto, que siguen a la variante
     · el contador «1 / 4» del carril de fotos
     · las fotos de la segunda en adelante, que se piden después de la
       primera y al irse a ver
     · la barra de compra fija del móvil, con la miniatura del aroma
     · las dos fechas de la entrega
     · añadir a la cesta sin recargar, con los complementos marcados (y el
       aroma elegido en los que lo tienen)
     · la línea del envío, que se vuelve a pedir al servidor al añadir y al
       cambiar de variante
     · el aviso «Avísame cuando vuelva»

   Y lo que NO hace: escribir precios o frases. Todo lo que se ve llega
   escrito por Liquid (el JSON de variantes, atributos data-, plantillas con
   __DESDE__) y aquí sólo se coloca. Lo único que se formatea en el navegador
   es la fecha de la entrega, con Intl y en el idioma de la página.
   ========================================================================== */

(function () {

  var MAXIMO = 99;
  var ESCRITORIO = "(min-width:1000px)";

  var ficha, formulario, variantes, selector;
  var campoCantidad, botonAnadir, cajaError;
  var avisame, carril, barra, botonBarra;
  var botonFuera = false;
  var refresco = null;
  var peticionesEnvio = 0;
  var observadorFotos = null;

  function sinMovimiento() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function enEscritorio() {
    return window.matchMedia && window.matchMedia(ESCRITORIO).matches;
  }

  /* ------------------------------------------------------------------ */
  /* Cantidad                                                            */
  /* ------------------------------------------------------------------ */

  function cantidad() {
    return Math.max(1, parseInt(campoCantidad.value, 10) || 1);
  }

  function actual() {
    if (!selector) return null;
    for (var i = 0; i < variantes.length; i++) {
      if (String(variantes[i].id) === String(selector.value)) return variantes[i];
    }
    return null;
  }

  /* Lo que todavía se puede añadir de la variante elegida: el stock menos lo
     que ya está en la cesta. Sin control de stock (o si se permite vender sin
     él) no hay más tope que MAXIMO. Nunca se puede pedir más de lo que hay. */
  function tope(variante) {
    if (!variante || variante.stock === null || variante.stock === undefined) return MAXIMO;
    return Math.max(0, Math.min(MAXIMO, variante.stock - (variante.en_cesta || 0)));
  }

  function ponerCantidad(n) {
    var limite = Math.max(1, tope(actual()));
    campoCantidad.value = Math.min(limite, Math.max(1, n));
    campoCantidad.max = limite;
    var mas = ficha.querySelector("[data-pdp-mas]");
    if (mas) mas.disabled = cantidad() >= limite;
  }

  /* El estado del botón según lo que queda por añadir: «Agotado», «Lo que queda
     ya está en tu cesta» (si ya está dentro todo lo que queda) o «Añadir a la
     cesta». En los dos primeros casos no deja añadir, y la cantidad y los
     complementos se esconden: no sirven para nada, y así el texto largo
     ocupa la fila entera en vez de salirse del botón. La barra fija copia
     siempre el estado del botón de arriba.

     Si el botón está diciendo «Añadida», sólo se cambia el texto al que
     volverá (cesta.js lo devuelve a los 1,6 s): la cesta releída llega a
     los 270 ms, y reescribirlo aquí cortaba la confirmación. */
  function pintarTope(variante) {
    if (!variante) return;
    var lleno = !variante.disponible || tope(variante) === 0;
    var texto = botonAnadir.getAttribute(!variante.disponible ? "data-texto-agotado"
      : lleno ? "data-texto-todo" : "data-texto-anadir");
    botonAnadir.disabled = lleno;
    botonAnadir.dataset.textoOriginal = texto;
    if (botonAnadir.textContent !== NuaSitio.textos.anadida) botonAnadir.textContent = texto;

    var caja = ficha.querySelector("[data-pdp-cantidad-caja]");
    if (caja) caja.hidden = lleno;
    var extras = ficha.querySelector(".ficha__extras");
    if (extras) {
      extras.hidden = lleno;
      /* Escondida, una casilla marcada no se ve pero seguiría viajando */
      if (lleno) {
        var casillas = extras.querySelectorAll("[data-pdp-extra]");
        for (var i = 0; i < casillas.length; i++) casillas[i].checked = false;
      }
    }
    if (!lleno) ponerCantidad(cantidad());
    copiarABarra();
    pintarBarra();
  }

  function iniciarCantidad() {
    var menos = ficha.querySelector("[data-pdp-menos]");
    var mas = ficha.querySelector("[data-pdp-mas]");

    if (menos) menos.addEventListener("click", function () { ponerCantidad(cantidad() - 1); });
    if (mas) mas.addEventListener("click", function () { ponerCantidad(cantidad() + 1); });

    /* Se puede escribir a mano, así que hay que corregir lo que se escriba: un
       campo de cantidad con «0» o con «-3» dentro lo rechaza el servidor y el
       cliente no sabe por qué. */
    campoCantidad.addEventListener("change", function () { ponerCantidad(cantidad()); });
  }

  /* ------------------------------------------------------------------ */
  /* Variantes                                                           */
  /* ------------------------------------------------------------------ */

  function leerVariantes() {
    var caja = ficha.querySelector("[data-pdp-variantes]");
    if (!caja) return [];
    try { return JSON.parse(caja.textContent) || []; }
    catch (e) { return []; }
  }

  /* Qué está marcado en cada grupo de radios, en el orden de las opciones */
  function elegidas() {
    var radios = ficha.querySelectorAll("[data-pdp-opcion]:checked");
    var valores = [];
    for (var i = 0; i < radios.length; i++) {
      valores[parseInt(radios[i].getAttribute("data-pdp-opcion"), 10)] = radios[i].value;
    }
    return valores;
  }

  function buscarVariante(valores) {
    for (var i = 0; i < variantes.length; i++) {
      var v = variantes[i];
      var coincide = true;
      for (var o = 0; o < valores.length; o++) {
        if (v.opciones[o] !== valores[o]) { coincide = false; break; }
      }
      if (coincide) return v;
    }
    return null;
  }

  /* Cambiar de variante NO recalcula nada: el precio, el precio anterior y la
     foto vienen ya escritos por el servidor dentro del JSON de la ficha. Aquí
     sólo se copian al sitio que les toca. */
  function pintarVariante(variante) {
    if (!variante) {
      botonAnadir.disabled = true;
      botonAnadir.textContent = botonAnadir.getAttribute("data-texto-agotado");
      botonAnadir.dataset.textoOriginal = botonAnadir.textContent;
      copiarABarra();
      return;
    }

    /* El <select> es el campo que se envía: es él quien lleva el name="id". */
    if (selector) selector.value = variante.id;

    var precio = ficha.querySelector("[data-pdp-precio]");
    if (precio) {
      var html = "";
      if (variante.antes) {
        html += '<s class="ficha__antes"><span class="nua-oculto-visual">' +
          NuaSitio.escapar(precio.getAttribute("data-texto-antes") || "") + " </span>" +
          NuaSitio.escapar(variante.antes) + "</s>" +
          '<span class="nua-oculto-visual">' +
          NuaSitio.escapar(precio.getAttribute("data-texto-actual") || "") + " </span>";
      }
      precio.innerHTML = html + NuaSitio.escapar(variante.precio);
    }

    var quedan = ficha.querySelector("[data-pdp-quedan]");
    if (quedan) {
      quedan.hidden = !variante.quedan;
      var textoQuedan = quedan.querySelector("[data-pdp-quedan-texto]") || quedan;
      if (variante.quedan) {
        textoQuedan.textContent = variante.quedan === 1
          ? quedan.getAttribute("data-texto-una")
          : quedan.getAttribute("data-texto-varias").replace("__N__", variante.quedan);
      }
    }

    /* La barra, antes de pintarTope: pintarTope copia el aviso de stock a
       la barra y mide lo que ocupa, y tiene que medirla ya con lo de esta
       variante. */
    if (barra) {
      var precioBarra = barra.querySelector("[data-pdp-barra-precio]");
      var nombreBarra = barra.querySelector("[data-pdp-barra-variante]");
      if (precioBarra) precioBarra.textContent = variante.precio;
      if (nombreBarra) nombreBarra.textContent = variante.titulo;
      /* La miniatura: la foto del aroma o, si no tiene, la de portada. Las
         dos direcciones las ha escrito Liquid (JSON de variantes y
         data-base); aquí sólo se elige. La caja mide 48 px con foto o sin
         ella, así que cambiarla no mueve nada. */
      var fotoBarra = barra.querySelector("[data-pdp-barra-foto]");
      var nuevaFoto = fotoBarra ? variante.miniatura || fotoBarra.getAttribute("data-base") : null;
      if (nuevaFoto && fotoBarra.getAttribute("src") !== nuevaFoto) fotoBarra.src = nuevaFoto;
    }

    /* Otra variante: si el botón aún decía «Añadida» (lo añadido era la
       de antes), deja de decirlo y pintarTope pone el texto de ésta. */
    if (botonAnadir.textContent === NuaSitio.textos.anadida) botonAnadir.textContent = "";
    var expres = ficha.querySelector("[data-pdp-expres]");
    if (expres) expres.hidden = !variante.disponible;
    pintarTope(variante);

    /* La referencia de «Seguridad del producto» es la de la variante */
    var sku = ficha.querySelector("[data-pdp-sku]");
    var filaSku = ficha.querySelector("[data-pdp-sku-fila]");
    if (sku) sku.textContent = variante.sku || "";
    if (filaSku) filaSku.hidden = !variante.sku;

    pintarAviso(variante);
    irAFoto(variante);
    cambiarUrl(variante);

    /* La línea del envío depende del precio y del stock de la variante
       («con esta…», «Llévate 3…») y la entrega sólo sale si se puede
       comprar: se vuelven a pedir al servidor en cada cambio. Mientras
       llegan, con un aroma agotado la fecha de entrega se esconde ya. */
    var entrega = ficha.querySelector("[data-pdp-entrega]");
    if (entrega && !variante.disponible) entrega.hidden = true;
    refrescarEnvio();
  }

  /* La URL se queda apuntando a la variante elegida, con replaceState y no con
     pushState: elegir un aroma no es navegar, y con pushState el botón
     «atrás» tendría que pulsarse una vez por cada opción probada antes de
     salir de la ficha. */
  function cambiarUrl(variante) {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set("variant", variante.id);
    window.history.replaceState({}, "", url.toString());
  }

  function iniciarVariantes() {
    var radios = ficha.querySelector("[data-pdp-radios]");
    if (!radios) return;   /* producto de una sola variante */

    radios.addEventListener("change", function () {
      pintarVariante(buscarVariante(elegidas()));
    });
  }

  /* ------------------------------------------------------------------ */
  /* Las fotos                                                           */
  /* ------------------------------------------------------------------ */

  /* Lleva el carril a la foto de la variante. En el móvil se desliza el
     carril, no la página: quien está eligiendo aroma a mitad de ficha no
     quiere que la página salte arriba. En escritorio las fotos van apiladas y
     el panel está pegado, así que se baja hasta la foto sólo si no se ve. */
  function irAFoto(variante) {
    if (!carril || !variante.media_id) return;
    var foto = carril.querySelector('[data-media-id="' + variante.media_id + '"]');
    if (!foto) return;
    var modo = sinMovimiento() ? "auto" : "smooth";
    /* Se pide antes de moverse: si no, se llegaría a un hueco del color del
       aroma y la foto aparecería después. */
    cargarFoto(foto);

    if (carril.scrollWidth > carril.clientWidth) {
      carril.scrollTo({ left: foto.offsetLeft, behavior: modo });
      return;
    }
    var caja = foto.getBoundingClientRect();
    if (caja.bottom < 0 || caja.top > window.innerHeight * 0.66) {
      foto.scrollIntoView({ block: "start", behavior: modo });
    }
  }

  /* De la segunda foto en adelante, el HTML trae la dirección en data-src y
     data-srcset (ver producto-principal.liquid), también en el <source> de
     escritorio de las verticales. Aquí se pasa a src y srcset: primero los
     <source> y el srcset, para que no se pida también la foto de src. */
  function cargarFoto(foto) {
    var img = foto && foto.querySelector ? foto.querySelector("img[data-src]") : null;
    if (!img) return;
    var otras = foto.querySelectorAll("source[data-srcset]");
    for (var i = 0; i < otras.length; i++) {
      otras[i].srcset = otras[i].getAttribute("data-srcset");
      otras[i].removeAttribute("data-srcset");
    }
    var fuentes = img.getAttribute("data-srcset");
    if (fuentes) img.srcset = fuentes;
    img.src = img.getAttribute("data-src");
    img.removeAttribute("data-srcset");
    img.removeAttribute("data-src");
  }

  /* Cuándo se piden. En el móvil y la tableta (el carril de lado) se mira
     contra el propio carril, que es el que se desliza, con un 20 % de margen
     por la derecha: la segunda, que asoma, «se ve» ya al montarlo (que es
     cuando ha llegado la primera, ver arrancarFotos); la tercera se pide a
     media pasada de la primera a la segunda, y cuando la segunda se para ya
     está llegando la que asoma. Un
     margen mayor no sirve: a 390 px, con un 100 % la tercera ya «se ve» al
     cargar y vuelven a pedirse todas de golpe. Desde 1000 px van apiladas y
     se mira contra la pantalla, con 600 px de margen por abajo. Al cruzar
     los 1000 px (una tableta que se gira) se vuelve a montar. */
  function observarFotos() {
    if (observadorFotos) observadorFotos.disconnect();
    observadorFotos = null;
    /* Se observa la foto entera (el <li>): el <picture> de dentro no pinta
       caja y nunca «se vería». */
    var pendientes = [];
    var diferidas = carril ? carril.querySelectorAll("img[data-src]") : [];
    for (var d = 0; d < diferidas.length; d++) pendientes.push(diferidas[d].closest(".carril__foto"));
    if (!pendientes.length) return;

    if (!("IntersectionObserver" in window)) {
      for (var i = 0; i < pendientes.length; i++) cargarFoto(pendientes[i]);
      return;
    }
    var opciones = enEscritorio()
      ? { rootMargin: "600px 0px" }
      : { root: carril, rootMargin: "0px 20% 0px 0px" };
    observadorFotos = new IntersectionObserver(function (entradas, observador) {
      for (var e = 0; e < entradas.length; e++) {
        if (!entradas[e].isIntersecting) continue;
        cargarFoto(entradas[e].target);
        observador.unobserve(entradas[e].target);
      }
    }, opciones);
    for (var j = 0; j < pendientes.length; j++) observadorFotos.observe(pendientes[j]);
  }

  /* Las demás fotos no se piden hasta que ha llegado la primera, que es la
     foto grande de la página (el LCP). La segunda asoma por la derecha y,
     pedida a la vez, se repartía con ella el ancho de banda: con 4G lento la
     primera llegaba medio segundo más tarde. Si antes se desliza el carril,
     no se espera: quien desliza quiere ver la siguiente. */
  function arrancarFotos() {
    var arrancado = false;
    function arrancar() {
      if (arrancado) return;
      arrancado = true;
      observarFotos();
    }
    var primera = carril.querySelector(".carril__imagen");
    if (!primera || primera.tagName !== "IMG" || primera.complete) {
      arrancar();
    } else {
      primera.addEventListener("load", arrancar, { once: true });
      primera.addEventListener("error", arrancar, { once: true });
      carril.addEventListener("scroll", arrancar, { once: true, passive: true });
    }
    if (window.matchMedia) {
      var consulta = window.matchMedia(ESCRITORIO);
      if (consulta.addEventListener) {
        consulta.addEventListener("change", function () { if (arrancado) observarFotos(); });
      }
    }
  }

  /* «1 / 4»: qué foto está a la vista. Se calcula con la foto que manda en el
     borde izquierdo del carril; al llegar al final, la última aunque la
     penúltima asome todavía. */
  function iniciarCarril() {
    carril = ficha.querySelector("[data-pdp-carril]");
    if (!carril) return;
    arrancarFotos();

    var contador = ficha.querySelector("[data-pdp-contador]");
    if (!contador) return;

    var fotos = carril.children;
    var pendiente = false;

    function contar() {
      pendiente = false;
      if (!fotos.length) return;
      var paso = fotos.length > 1 ? fotos[1].offsetLeft - fotos[0].offsetLeft : 1;
      var indice = Math.round(carril.scrollLeft / (paso || 1));
      if (carril.scrollLeft + carril.clientWidth >= carril.scrollWidth - 2) indice = fotos.length - 1;
      contador.textContent = Math.min(fotos.length, Math.max(1, indice + 1));
    }

    carril.addEventListener("scroll", function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(contar);
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ */
  /* La barra de compra del móvil                                         */
  /* ------------------------------------------------------------------ */

  /* Copia al botón de la barra el texto y el estado del de arriba: son el
     mismo botón en dos sitios. Mientras la barra dice «Añadida» sólo se
     cambia el texto al que volverá, como en pintarTope. Y lo mismo con
     «¡Solo quedan…!»: la barra lleva el aviso de la ficha tal cual (el
     texto lo ha escrito Liquid o pintarVariante), y sin él la fila se va. */
  function copiarABarra() {
    if (!botonBarra) return;
    var texto = botonAnadir.dataset.textoOriginal || botonAnadir.textContent;
    botonBarra.disabled = botonAnadir.disabled;
    botonBarra.dataset.textoOriginal = texto;
    if (botonBarra.textContent !== NuaSitio.textos.anadida) botonBarra.textContent = texto;

    var quedan = ficha.querySelector("[data-pdp-quedan]");
    var quedanBarra = barra.querySelector("[data-pdp-barra-quedan]");
    if (!quedan || !quedanBarra) return;
    var origen = quedan.querySelector("[data-pdp-quedan-texto]") || quedan;
    var destino = quedanBarra.querySelector("[data-pdp-barra-quedan-texto]") || quedanBarra;
    destino.textContent = origen.textContent;
    quedanBarra.hidden = quedan.hidden;
  }

  /* Se ve sólo en el móvil, cuando ya se ha bajado más allá del botón de
     verdad y si queda algo que añadir de la variante. Mientras
     se ve, el body reserva su alto abajo para que no tape el final de la
     página. */
  function pintarBarra() {
    if (!barra) return;
    var variante = actual();
    var ver = botonFuera && !enEscritorio() && !!variante && variante.disponible && tope(variante) > 0;
    barra.hidden = !ver;
    document.body.classList.toggle("ficha-con-barra", ver);
    /* Lo que reserva el body es lo que mide la barra: con el nombre en dos
       líneas (el pack) es más alta que el botón. */
    if (ver) document.body.style.setProperty("--ficha-barra-alto", barra.offsetHeight + "px");
  }

  /* El botón «ha quedado atrás» si no está entero dentro de la pantalla y
     se ha ido por arriba: con los umbrales 0 y 1, el aviso llega al empezar
     a salir y al acabar de entrar. Lo que queda debajo de la cabecera pegada
     tampoco se ve: por eso el borde de arriba se baja lo que mide. Mientras
     el botón está todavía por debajo de la pantalla la barra no sale: hasta
     el 30-09-2026 salía también entonces (en un iPhone con las barras de
     Safari, nada más llegar), y en la ficha se veía una barra de compra por
     encima del botón al que duplica. */
  function iniciarBarra() {
    barra = ficha.querySelector("[data-pdp-barra]");
    if (!barra || !("IntersectionObserver" in window)) return;
    botonBarra = barra.querySelector("[data-pdp-barra-boton]");

    var cabecera = document.querySelector(".cabecera-fija");
    var alto = cabecera ? Math.round(cabecera.getBoundingClientRect().height) : 0;
    new IntersectionObserver(function (entradas) {
      var entrada = entradas[entradas.length - 1];
      botonFuera = entrada.intersectionRatio < 1 && entrada.boundingClientRect.top < alto;
      pintarBarra();
    }, { threshold: [0, 1], rootMargin: "-" + alto + "px 0px 0px 0px" }).observe(botonAnadir);

    if (window.matchMedia) {
      var consulta = window.matchMedia(ESCRITORIO);
      if (consulta.addEventListener) consulta.addEventListener("change", pintarBarra);
    }
    copiarABarra();
  }

  /* ------------------------------------------------------------------ */
  /* La entrega y el envío                                               */
  /* ------------------------------------------------------------------ */

  /* Suma días laborables (de lunes a viernes) a partir de hoy. No sabe de
     festivos, y por eso la frase dice «(estimado)». */
  function sumarLaborables(desde, dias) {
    var fecha = new Date(desde.getTime());
    var sumados = 0;
    while (sumados < dias) {
      fecha.setDate(fecha.getDate() + 1);
      var d = fecha.getDay();
      if (d !== 0 && d !== 6) sumados++;
    }
    return fecha;
  }

  /* «vie 3 oct»: día de la semana, número y mes, en el idioma de la página.
     Se arma por partes para quitar la coma que Intl pone tras el día de la
     semana («vie, 3 oct»), que dentro de la frase sobra. */
  function escribirFecha(fecha, idioma) {
    var formato = new Intl.DateTimeFormat(idioma, { weekday: "short", day: "numeric", month: "short" });
    if (!formato.formatToParts) return formato.format(fecha);
    var partes = formato.formatToParts(fecha);
    var trozos = { weekday: "", day: "", month: "" };
    for (var i = 0; i < partes.length; i++) {
      if (trozos.hasOwnProperty(partes[i].type)) trozos[partes[i].type] = partes[i].value;
    }
    return (trozos.weekday + " " + trozos.day + " " + trozos.month).trim();
  }

  function ponerFechas() {
    var linea = ficha.querySelector("[data-pdp-entrega]");
    if (!linea || !window.Intl) return;
    var texto = linea.querySelector("[data-pdp-entrega-texto]");
    var plantilla = linea.getAttribute("data-plantilla");
    if (!texto || !plantilla) return;

    var numero = function (nombre) { return parseInt(linea.getAttribute(nombre), 10) || 0; };
    var hoy = new Date();
    var idioma = document.documentElement.lang || "es";
    var desde = sumarLaborables(hoy, numero("data-prep-min") + numero("data-trans-min"));
    var hasta = sumarLaborables(hoy, numero("data-prep-max") + numero("data-trans-max"));

    try {
      texto.textContent = plantilla
        .replace("__DESDE__", escribirFecha(desde, idioma))
        .replace("__HASTA__", escribirFecha(hasta, idioma));
    } catch (e) { /* sin fechas se queda el plazo en días, que ya es correcto */ }
  }

  /* La lista de confianza la escribe el servidor con la cesta de verdad y la
     variante elegida. Tras añadir, al cambiar de variante o si la cesta
     cambia desde el cajón, se vuelve a pedir la sección por la Section
     Rendering API y se sustituye sólo esa lista. Se agrupan las peticiones
     que llegan juntas (añadir dispara también el aviso de «la cesta ha
     cambiado»), y si se prueban aromas deprisa sólo vale la última
     respuesta: una anterior que llegue tarde no pisa a la buena. */
  function refrescarEnvio() {
    clearTimeout(refresco);
    refresco = setTimeout(function () {
      var id = ficha.getAttribute("data-seccion");
      var lista = ficha.querySelector("[data-pdp-envio]");
      if (!id || !lista || !window.fetch) return;

      var esta = ++peticionesEnvio;
      var url = window.location.pathname + "?variant=" + encodeURIComponent(selector.value) +
        "&sections=" + encodeURIComponent(id);
      /* Sin cabecera Accept: con «application/json» Shopify contesta con el
         producto en JSON en vez de con la sección pintada. */
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (datos) {
          if (esta !== peticionesEnvio) return;
          var nueva = NuaSitio.seccion(datos[id], "[data-pdp-envio]");
          var vieja = ficha.querySelector("[data-pdp-envio]");
          if (!nueva || !vieja) return;
          vieja.parentNode.replaceChild(nueva, vieja);
          ponerFechas();
        })
        .catch(function () {});
    }, 120);
  }

  /* ------------------------------------------------------------------ */
  /* Añadir a la cesta                                                   */
  /* ------------------------------------------------------------------ */

  function error(mensaje) {
    if (!cajaError) return;
    cajaError.textContent = mensaje || "";
    cajaError.hidden = !mensaje;
  }

  /* Un complemento con aromas lleva su <select>. Al cambiar de aroma, la
     frase (con su precio) y la miniatura se copian de la <option> elegida,
     donde las ha escrito Liquid, y la casilla pasa a llevar esa variante. */
  function pintarExtra(campo) {
    var fila = campo.closest("[data-pdp-extra-fila]");
    var opcion = campo.options[campo.selectedIndex];
    if (!fila || !opcion) return;
    var casilla = fila.querySelector("[data-pdp-extra]");
    var texto = fila.querySelector("[data-pdp-extra-texto]");
    var foto = fila.querySelector("[data-pdp-extra-foto]");
    if (casilla) casilla.value = campo.value;
    if (texto && opcion.getAttribute("data-texto")) texto.textContent = opcion.getAttribute("data-texto");
    if (foto) {
      var url = opcion.getAttribute("data-foto") || foto.getAttribute("data-base");
      if (url && foto.getAttribute("src") !== url) foto.src = url;
    }
  }

  /* Al arrancar se pinta cada uno una vez: al volver atrás, el navegador
     puede devolver el <select> en otro aroma que el que escribió Liquid. */
  function iniciarExtras() {
    var selects = ficha.querySelectorAll("[data-pdp-extra-aroma]");
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].selectedIndex > 0) pintarExtra(selects[i]);
      selects[i].addEventListener("change", function (ev) { pintarExtra(ev.currentTarget); });
    }
  }

  /* La variante que se añade de cada complemento marcado: la de su <select>
     si tiene aromas y, si no, la de la casilla. Se lee del <select> al
     enviar, que es lo que la clienta está viendo, y no se fía de que la
     casilla se haya puesto al día. */
  function extrasMarcados() {
    var casillas = ficha.querySelectorAll("[data-pdp-extra]:checked");
    var ids = [];
    for (var i = 0; i < casillas.length; i++) {
      var fila = casillas[i].closest("[data-pdp-extra-fila]");
      var aroma = fila ? fila.querySelector("[data-pdp-extra-aroma]") : null;
      ids.push(aroma && aroma.value ? aroma.value : casillas[i].value);
    }
    return ids;
  }

  /* El producto y sus complementos marcados van en UNA petición
     (NuaCesta.anadir con una lista): o entran todos o ninguno, y la cesta se
     repinta una vez. */
  function anadirTodo(id, cuantas, extras, disparador) {
    if (!extras.length) return NuaCesta.anadir(id, cuantas, disparador);

    var lineas = [{ id: parseInt(id, 10), quantity: cuantas }];
    for (var i = 0; i < extras.length; i++) lineas.push({ id: parseInt(extras[i], 10), quantity: 1 });
    return NuaCesta.anadir(lineas, null, disparador);
  }

  /* Vuelve a contar cuántas unidades de cada variante hay en la cesta, con la
     cesta de verdad (/cart.js), y repinta el tope. Se llama cuando la cesta
     cambia sin salir de la ficha (se quita algo desde el cajón) y cuando
     Shopify rechaza un «Añadir»: casi siempre es porque la cesta ya tiene
     todo el stock (otra pestaña, o la ficha se abrió antes de añadirlo), y
     así el botón pasa a «Lo que queda ya está en tu cesta» en vez de seguir
     invitando a pulsar. */
  function releerCesta() {
    if (!window.fetch) return;
    fetch(NuaSitio.rutas.cesta + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cesta) {
        for (var i = 0; i < variantes.length; i++) variantes[i].en_cesta = 0;
        for (var j = 0; j < cesta.items.length; j++) {
          for (var k = 0; k < variantes.length; k++) {
            if (String(variantes[k].id) === String(cesta.items[j].variant_id)) {
              variantes[k].en_cesta += cesta.items[j].quantity;
            }
          }
        }
        pintarTope(actual());
      })
      .catch(function () {});
  }

  function iniciarCompra() {
    formulario.addEventListener("submit", function (ev) {
      ev.preventDefault();
      error("");

      var id = selector ? selector.value : null;
      if (!id) return;

      /* Desde la barra fija o desde el botón de arriba: el que se ha pulsado
         es el que dice «Añadida» y al que vuelve el foco al cerrar el cajón. */
      var pulsado = ev.submitter && botonBarra && ev.submitter === botonBarra ? botonBarra : botonAnadir;
      botonAnadir.disabled = true;
      if (botonBarra) botonBarra.disabled = true;

      var elegida = actual();
      var cuantas = cantidad();
      var casillas = ficha.querySelectorAll("[data-pdp-extra]:checked");
      var extras = extrasMarcados();

      anadirTodo(id, cuantas, extras, pulsado)
        .then(function () {
          /* Lo añadido cuenta ya como «en la cesta»: el tope baja sin recargar */
          if (elegida) elegida.en_cesta = (elegida.en_cesta || 0) + cuantas;
          if (elegida && tope(elegida) === 0) {
            botonAnadir.dataset.textoOriginal = botonAnadir.getAttribute("data-texto-todo");
          }
          NuaCesta.confirmar(pulsado);
          /* Los complementos ya van en la cesta: se desmarcan para que no se
             vuelvan a añadir si se pulsa otra vez. */
          for (var j = 0; j < casillas.length; j++) casillas[j].checked = false;
          /* La cesta ya lleva las que había: el contador de la ficha vuelve a 1
             para que no se sumen sin querer al pulsar otra vez. */
          ponerCantidad(1);
          refrescarEnvio();
        })
        .catch(function (e) {
          /* El motivo es el que manda Shopify («Tu carrito ya tiene la
             cantidad máxima de este artículo.»), en el idioma de la tienda.
             sitio.js marca esos errores con `tienda`; cualquier otro (un
             fallo de programación, en inglés) se queda en la frase genérica. */
          error(e && e.tienda && e.message ? e.message : NuaSitio.textos.cestaError);
          /* Si Shopify dice que no, casi siempre es que la cesta cambió fuera
             de esta página: se vuelven a leer el tope y la línea del envío. */
          releerCesta();
          refrescarEnvio();
        })
        .then(function () {
          botonAnadir.disabled = elegida ? tope(elegida) === 0 || !elegida.disponible : false;
          if (botonBarra) botonBarra.disabled = botonAnadir.disabled;
        });
    });
  }

  /* ------------------------------------------------------------------ */
  /* «Avísame cuando vuelva»                                             */
  /* ------------------------------------------------------------------ */

  /* En los productos con el aviso activado, con la variante agotada sale un
     segundo botón, «Avísame cuando vuelva», debajo del de «Agotado». La
     etiqueta aviso-<sku> y el nombre del modal siguen a la variante elegida,
     porque es la etiqueta que mira el flujo de Shopify Flow al reponer. */
  function pintarAviso(variante) {
    if (!avisame) return;
    var abrir = ficha.querySelector("[data-pdp-avisame-abrir]");
    if (abrir) abrir.hidden = variante.disponible;

    var etiquetas = avisame.querySelector("[data-pdp-aviso-etiquetas]");
    if (etiquetas && variante.aviso) etiquetas.value = "aviso-stock, aviso-" + variante.aviso;

    var nombre = avisame.querySelector("[data-pdp-avisame-producto]");
    if (nombre && variante.titulo && nombre.getAttribute("data-base")) {
      nombre.textContent = nombre.getAttribute("data-base") + " · " + variante.titulo;
    }
  }

  function abrirAvisame() {
    if (!avisame || typeof avisame.showModal !== "function") return;
    avisame.showModal();
    var campo = avisame.querySelector("input[type='email']");
    if (campo) campo.focus();
  }

  function iniciarAviso() {
    avisame = document.querySelector("[data-pdp-avisame]");
    if (!avisame) return;

    /* El nombre del producto sin la variante, para reescribir sólo la variante */
    var nombre = avisame.querySelector("[data-pdp-avisame-producto]");
    if (nombre && variantes.length > 1) {
      nombre.setAttribute("data-base", nombre.textContent.split(" · ")[0]);
    }

    var abrir = ficha.querySelector("[data-pdp-avisame-abrir]");
    if (abrir) abrir.addEventListener("click", abrirAvisame);

    var cerrar = avisame.querySelector("[data-pdp-avisame-cerrar]");
    if (cerrar) cerrar.addEventListener("click", function () { avisame.close(); });

    /* Un clic fuera de la caja —en el fondo oscuro— también lo cierra: el
       clic en el fondo le llega al propio <dialog>, no a nada de dentro. */
    avisame.addEventListener("click", function (evento) {
      if (evento.target === avisame) avisame.close();
    });

    var formularioAviso = avisame.querySelector("[data-pdp-avisame-formulario]");
    if (!formularioAviso || !window.fetch) return;

    /* Se envía sin recargar: con una recarga, el «gracias» de Shopify saldría
       también en el boletín del pie, que es otro formulario de clientes. Si la
       respuesta no confirma el alta —casi siempre porque Shopify quiere
       enseñar su captcha—, el formulario se envía a la manera normal. */
    formularioAviso.addEventListener("submit", function (evento) {
      var respuesta = formularioAviso.querySelector("[data-pdp-aviso-respuesta]");
      var boton = formularioAviso.querySelector("button[type='submit']");
      evento.preventDefault();
      boton.disabled = true;

      fetch(formularioAviso.action, { method: "POST", body: new FormData(formularioAviso), headers: { Accept: "text/html" } })
        .then(function (r) {
          if (!r.ok || r.url.indexOf("customer_posted=true") === -1) throw new Error();
          var fila = formularioAviso.querySelector("[data-pdp-avisame-fila]");
          var nota = formularioAviso.querySelector(".avisame__nota");
          if (fila) fila.hidden = true;
          if (nota) nota.hidden = true;
          respuesta.textContent = formularioAviso.getAttribute("data-texto-gracias");
          respuesta.hidden = false;
        })
        .catch(function () {
          formularioAviso.submit();
        });
    });
  }

  /* ------------------------------------------------------------------ */

  function iniciar() {
    ficha = document.querySelector("[data-pdp]");
    if (!ficha) return;

    /* Las fotos y las fechas no dependen del formulario: van primero, así
       funcionan también en un producto que no se puede comprar. */
    iniciarCarril();
    ponerFechas();

    formulario = ficha.querySelector("form[action*='/cart/add']");
    campoCantidad = ficha.querySelector("[data-pdp-cantidad]");
    botonAnadir = ficha.querySelector("[data-pdp-anadir]");
    selector = ficha.querySelector("[data-pdp-variante]");
    cajaError = ficha.querySelector("[data-pdp-error]");
    if (!formulario || !campoCantidad || !botonAnadir || !selector) return;

    variantes = leerVariantes();

    iniciarAviso();
    iniciarCantidad();
    iniciarBarra();
    /* El servidor ya pinta el botón en su estado; esto lo deja en un solo
       texto (sin JavaScript, con un aroma agotado, el botón lleva también
       «Añadir a la cesta» para comprar otro desde el <select>) y apagado si
       la variante que llega en la URL no se puede añadir. */
    pintarTope(actual());

    /* Si la cesta cambia sin salir de la ficha (se quita algo desde el cajón),
       se vuelve a mirar cuántas unidades de cada variante hay dentro y se
       vuelve a pedir la línea del envío. */
    document.addEventListener("nua:cesta-cambiada", function () {
      refrescarEnvio();
      releerCesta();
    });
    iniciarVariantes();
    iniciarExtras();
    iniciarCompra();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
})();
